import { PLAN_KEY } from '../../constants'
import { getValueReduxUtil } from '../../../../redux'

function getOriginalParentIdPlanUtil (plan) {
  return getValueReduxUtil(
    plan, PLAN_KEY.ORIGINAL_PARENT_ID
  )
}

export default getOriginalParentIdPlanUtil
